
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.53 11c-5.42 6.76-4.49 16.64 2.18 22.25 6.76 5.69 16.86 4.81 22.54-1.95 4.92-5.86 4.99-14.35.23-20.29H11.53V11zm17.15 3.06c1.28 0 2.32 1.04 2.32 2.32 0 1.28-1.04 2.32-2.32 2.32-1.28 0-2.32-1.04-2.32-2.32 0-1.28 1.04-2.32 2.32-2.32zm-9.21 0c1.28 0 2.32 1.04 2.32 2.32 0 1.28-1.04 2.32-2.32 2.32-1.28 0-2.32-1.04-2.32-2.32a2.309 2.309 0 012.32-2.32zm-5.18 11.5a2.86 2.86 0 112.86-2.86 2.872 2.872 0 01-2.86 2.86zm5.1 6.86c-1.28 0-2.32-1.04-2.32-2.32 0-1.28 1.04-2.32 2.32-2.32 1.28 0 2.32 1.04 2.32 2.32 0 1.28-1.04 2.32-2.32 2.32zm1.18-9.14A3.43 3.43 0 1124 26.71c-1.89-.01-3.43-1.54-3.43-3.43zm8.04 9.14c-1.28 0-2.32-1.04-2.32-2.32 0-1.28 1.04-2.32 2.32-2.32 1.28 0 2.32 1.04 2.32 2.32 0 1.28-1.04 2.32-2.32 2.32zm5.1-6.86a2.86 2.86 0 11-.001-5.719 2.86 2.86 0 01.001 5.719z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M37.41 9C40.37 12.31 42 16.54 42 21c0 9.93-8.07 18-18 18S6 30.93 6 21c0-4.46 1.63-8.69 4.59-12h26.82zm.86-2H9.73C6.19 10.61 4 15.55 4 21c0 11.05 8.95 20 20 20s20-8.95 20-20c0-5.45-2.19-10.39-5.73-14z","fill":"currentColor"}})])
          )
        }
      }
    